import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap"
import { Link } from "gatsby-link"
import "./navbar.scss"

class NavbarMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      collapse: false,
      sticky: false,
      sections: this.props.sections
        ? this.props.sections
        : [
            "home",
            "about",
            "services",
            "portfolio",
            "testimonials",
            "clients",
            "team",
            "blog",
            "contact",
          ],
      menuOptions: [
        {
          menuTitle: "Inicio",
          serviceTitle: { url: "/", content: "Inicio" },
          children: [
            //row
            // {
            //     serviceList: [ //col
            //         {
            //             serviceIcon: <SvgIconD/>,
            //             serviceTitle: {url: "/", content:"Inicio"},
            //             serviceDescription: "Convierte tu visión en realidad digital, con nuestro diseño web innovador. Diseño de páginas web con plantillas premium o desde cero, totalmente personalizados.",
            //             serviceBadge: "Páginas Web"
            //         }
            //     ],
            // }
          ],
          offertList: {
            title: "Desarrollo de Aplicaciones Móviles y Web",
            description1: "Cada proyecto es diferente y lo tratamos como tal.",
            description2: "+57 310 276 76 75",
            description3: "+1 (954) 603 47 47",
            background: "bg-op2", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "APP",
          children: [
            //row
            {
              serviceList: [
                //col
                {
                  serviceIcon: "menu/builder.png",
                  serviceTitle: { url: "/diseno-web", content: "Diseño Web" },
                  serviceDescription:
                    "Convierte tu visión en realidad digital, con nuestro diseño web innovador. Diseño de páginas web con plantillas premium o desde cero, totalmente personalizados.",
                  serviceBadge: "Páginas Web",
                },
                {
                  serviceIcon: "menu/mobile.png",
                  serviceTitle: {
                    url: "/desarrollo-de-aplicaciones-moviles",
                    content: "Aplicaciones Móviles",
                  },
                  serviceDescription:
                    "Desde aplicaciones para redes sociales hasta herramientas de productividad y juegos adictivos, las aplicaciones móviles están en todas partes y juegan un papel crucial en nuestra vida diaria.",
                  serviceBadge: "APPs",
                },
                {
                  serviceIcon: "menu/web.png",
                  serviceTitle: {
                    url: "/desarrollo-de-software",
                    content: "Desarrollo de Software",
                  },
                  serviceDescription:
                    "El desarrollo de software juega un papel fundamental en la creación de soluciones innovadoras y funcionales para una amplia gama de necesidades. Desde plataformas web, hasta sistemas empresariales complejos.",
                  serviceBadge: "Web",
                },
              ],
            },
          ],
          offertList: {
            title: "Desarrollo de Aplicaciones Móviles y Web",
            description1: "Cada proyecto es diferente y lo tratamos como tal.",
            description2: "+57 310 276 76 75",
            description3: "+1 (954) 603 47 47",
            background: "bg-op2", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "Hosting",
          children: [
            //row max 2 rows
            {
              serviceList: [
                //max 3 cols
                {
                  serviceIcon: "menu/linux.png",
                  serviceTitle: {
                    url: "/hosting-colombia",
                    content: "Hosting Colombia",
                  },
                  serviceDescription:
                    "Alojamiento Web confiable, potente y rápido en RAID 10.",
                  serviceBadge: "SSD",
                },
                {
                  serviceIcon: "menu/cpanel.png",
                  serviceTitle: {
                    url: "/hosting-cpanel",
                    content: "Hosting cPanel",
                  },
                  serviceDescription:
                    "Discos SSD en arreglos RAID 10 con dominio GRATIS.",
                  serviceBadge: "cPanel",
                },
                {
                  serviceIcon: "menu/wordpress.png",
                  serviceTitle: {
                    url: "/cloud-wordpress-hosting",
                    content: "Cloud WordPress Hosting",
                  },
                  serviceDescription:
                    "Hospedaje en la Nube para mayor flexibilidad y escalabilidad.",
                  serviceBadge: "WordPress",
                },
              ],
            },
          ],
          offertList: {
            title: "Dominios",
            description:
              "Registre o transfiera su dominio a VASCO Solutions. Administración simple y rápida.",
            background: "bg-op1", //bg-op1 bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "VPS",
          children: [
            //row
            {
              serviceList: [
                //max 3 cols
                {
                  serviceIcon: "menu/vps.png",
                  serviceTitle: { url: "/vps", content: "VPS en RAID 10" },
                  serviceDescription:
                    "Experimenta el poder sin igual de nuestro VPS en RAID 10, una solución única en Colombia.",
                  serviceBadge: "SSD",
                },
                {
                  serviceIcon: "menu/vps.png",
                  serviceTitle: { url: "/vps-kvm", content: "VPS KVM" },
                  serviceDescription:
                    "Opta por un VPS con KVM para disfrutar de aislamiento de recursos, flexibilidad y un rendimiento superior.",
                  serviceBadge: "SSD - HDD",
                },
                {
                  serviceIcon: "menu/managed-server.png",
                  serviceTitle: {
                    url: "/vps-administrado",
                    content: "VPS Administrado NVME",
                  },
                  serviceDescription:
                    "Libérate de preocupaciones técnicas con nuestro VPS administrado. Delegamos la gestión para que puedas centrarte en tu negocio.",
                  serviceBadge: "Gestionado",
                },
              ],
            },
          ],
          offertList: {
            title: "Servidores Virtuales Privados (VPS)",
            description4:
              "Los Servidores VPS ofrecen un rendimiento robusto y aislamiento de recursos para garantizar una presencia en línea sin igual. Ofrecemos con o sin administración",
            description5: "Desde $60.000/Mes",
            background: "bg-op3", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "Cloud",
          children: [
            //row max 2 rows
            {
              serviceList: [
                //max 3 cols
                {
                  serviceIcon: "menu/cloud-managed.png",
                  serviceTitle: { url: "/cloud", content: "Cloud" },
                  serviceDescription:
                    "Hospedaje web en la Nube para mayor flexibilidad y escalabilidad.",
                  serviceBadge: "NUBE",
                },
                {
                  serviceIcon: "menu/wordpress.png",
                  serviceTitle: {
                    url: "/cloud-wordpress-hosting",
                    content: "Cloud WordPress Hosting",
                  },
                  serviceDescription:
                    "Hospedaje en la Nube para mayor flexibilidad y escalabilidad.",
                  serviceBadge: "WordPress",
                },
              ],
            },
          ],
          offertList: {
            title: "Dominios",
            description:
              "Registre o transfiera su dominio a VASCO Solutions. Administración simple y rápida.",
            background: "bg-op4", //bg-op1 bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "Dedicado",
          serviceTitle: { url: "/servidores-dedicados", content: "Dedicado" },
          children: [
            //row
            //{
            //    serviceList: [ //max 3 cols
            //        {
            //           serviceIcon: <SvgIcon/>,
            //           serviceTitle: {url: "/servidores-dedicados", content:"Servidores Dedicados"},
            //           serviceDescription: "Experimenta el poder sin igual de nuestro VPS en RAID 10, una solución única en Colombia.",
            //           serviceBadge: "SSD"
            //       },
            //  ],
            //},
          ],
          offertList: {
            title: "Servidores Virtuales Privados (VPS)",
            description4:
              "Los Servidores VPS ofrecen un rendimiento robusto y aislamiento de recursos para garantizar una presencia en línea sin igual. Ofrecemos con o sin administración",
            description5: "Desde $55.000/Mes",
            background: "bg-op6", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "SSL",
          children: [
            //row
            {
              serviceList: [
                //max 3 cols
                {
                  serviceIcon: "menu/ssl-colombia.png",
                  serviceTitle: {
                    url: "/certificados-ssl",
                    content: "Certificados SSL",
                  },
                  serviceDescription:
                    "Elige el nivel de validación y la cantidad de protección SSL que se alinee mejor con la naturaleza y propósito de tu sitio o aplicación.",
                  serviceBadge: "SSL",
                },
                {
                  serviceIcon: "menu/ssl-colombia.png",
                  serviceTitle: {
                    url: "/ssl-digicert",
                    content: "SSL DigiCert",
                  },
                  serviceDescription:
                    "Descubramos juntos la magnitud de esta solución y por qué se ha convertido en un referente en el mundo de la seguridad en línea.",
                  serviceBadge: "Digicert",
                },
                {
                  serviceIcon: "menu/ssl-colombia.png",
                  serviceTitle: { url: "/rapidssl", content: "RapidSSL" },
                  serviceDescription:
                    "RapidSSL es una autoridad de certificación (CA) que ofrece certificados SSL de alta calidad a precios asequibles.",
                  serviceBadge: "RapidSSL",
                },
              ],
            },
            {
              serviceList: [
                //max 3 cols
                {
                  serviceIcon: "menu/ssl-colombia.png",
                  serviceTitle: { url: "/ssl-sectigo", content: "SSL Sectigo" },
                  serviceDescription:
                    "Sectigo es una autoridad de certificación que ofrece una amplia gama de soluciones de seguridad digital, incluidos los SSL.",
                  serviceBadge: "Sectigo",
                },
                {
                  serviceIcon: "menu/ssl-colombia.png",
                  serviceTitle: { url: "/ssl-vasco", content: "SSL VASCO" },
                  serviceDescription:
                    "SSL (Secure Sockets Layer). Estos certificados SSL son herramientas esenciales para garantizar la seguridad de los sitios web.",
                  serviceBadge: "VASCO",
                },
                {
                  serviceIcon: "menu/ssl-colombia.png",
                  serviceTitle: { url: "/ssl-thawte", content: "SSL Thawte" },
                  serviceDescription:
                    "Thawte emerge como una autoridad de certificación pionera, con una trayectoria que se remonta a 1995, sinónimo de calidad y confiabilidad.",
                  serviceBadge: "Thawte",
                },
              ],
            },
          ],
          offertList: {
            title: "SSL GeoTrust",
            descriptiong1:
              "GeoTrust, garantía de una marca líder: Certificados SSL que fusionan confiabilidad y protección. Asegure desde 1 Dominio hasta 250 con un solo certificado. Servidores ilimitados",
            descriptiong2: "Certificados SSL SAN (5 dominios incluidos)",
            link: "/certificados-digitales-ssl-san-ucc",
            description6: "Certificados SSL SAN >>",
            link1: "/ssl-geotrust",
            description7: "SSL GeoTrust >>",
            background: "bg-op5", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "CYBER",
          children: [
            //row
            {
              serviceList: [
                //max 3 cols
                {
                  serviceIcon: "menu/sitelock.png",
                  serviceTitle: { url: "/sitelock", content: "SiteLock" },
                  serviceDescription:
                    "SiteLock está ahí para ti las 24 horas del día, los 7 días de la semana, asegurando que tu sitio esté protegido ante las amenazas.",
                  serviceBadge: "Seguridad Web",
                },
                {
                  serviceIcon: "menu/sgsi-iso27001.png",
                  serviceTitle: {
                    url: "/servicios-ciberseguridad-colombia",
                    content: "Ciberseguridad",
                  },
                  serviceDescription:
                    "Protege tu negocio con soluciones contra ciberdelincuentes, asesoría experta y sistemas confiables.",
                  serviceBadge: "Colombia",
                },
                {
                  serviceIcon: "menu/sgsi-iso27001.png",
                  serviceTitle: {
                    url: "/sgsi-iso27001-colombia",
                    content: "SGSI - ISO 27001",
                  },
                  serviceDescription:
                    "Sistema estructurado para gestionar la seguridad de la información en toda la organización.",
                  serviceBadge: "ISO27001",
                },
                {
                  serviceIcon: "menu/sgsi-iso27001.png",
                  serviceTitle: { url: "/certimail", content: "Certimail" },
                  serviceDescription:
                    "Los certificados SSL S/MIME son una herramienta invaluable para proteger, firmar y encriptar tu correo y documentos electrónicos. ",
                  serviceBadge: "S/MIME",
                },
                {
                  serviceIcon: "menu/sgsi-iso27001.png",
                  serviceTitle: { url: "/seguridad-informatica-colombia", content: "Seguridad Informática" },
                  serviceDescription:
                    "Protección técnica de sistemas informáticos: hardware, software y redes internas.",
                  serviceBadge: "Digital",
                },
                {
                  serviceIcon: "menu/sgsi-iso27001.png",
                  serviceTitle: { url: "/gobierno-digital-colombia", content: "Gobierno Digital" },
                  serviceDescription:
                    "Enfocada en entidades gubernamentales y proveedores o contratistas del estado",
                  serviceBadge: "Estado",
                },
              ],
            },
          ],
          offertList: {
            titlen: "Seguridad garantizada",
            description8:
              "En VASCO Solutions, protegemos tus datos con soluciones integrales de Ciberseguridad, SSL y Certimail, asegurando la autenticidad, confidencialidad, integridad y disponibilidad de tus comunicaciones en línea.",
            background: "bg-op7", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "SEO",
          serviceTitle: { url: "/seo", content: "SEO" },
          children: [
            //row
            //{
            //    serviceList: [ //max 3 cols
            //        {
            //            serviceIcon: <SvgIconSEO/>,
            //            serviceTitle: {url: "/seo", content:"SEO"},
            //            serviceDescription: "Experimenta el poder sin igual de nuestro VPS en RAID 10, una solución única en Colombia.",
            //            serviceBadge: "DA70+"
            //        },
            //    ],
            //
            //}
          ],
          offertList: {
            title: "Servidores Virtuales Privados (VPS)",
            description4:
              "Los Servidores VPS ofrecen un rendimiento robusto y aislamiento de recursos para garantizar una presencia en línea sin igual. Ofrecemos con o sin administración",
            description5: "Desde $55.000/Mes",
            background: "bg-op6", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "Correo",
          children: [
            //row
            {
              serviceList: [
                //max 3 cols
                {
                  serviceIcon: "menu/email.png",
                  serviceTitle: {
                    url: "/correo-corporativo",
                    content: "Correo Corporativo",
                  },
                  serviceDescription:
                    "El uso de un correo electrónico corporativo, no solo fortalece la imagen de tu marca de manera profesional, sino que también te posiciona como un jugador serio en tu industria o sector económico.",
                  serviceBadge: "Email",
                },
                {
                  serviceIcon: "menu/google.png",
                  serviceTitle: {
                    url: "/google-workspace",
                    content: "Google Workspace",
                  },
                  serviceDescription:
                    "Google Workspace es una suite de aplicaciones y herramientas de productividad en la nube diseñadas para ayudar a las empresas a trabajar de manera más inteligente y eficiente.",
                  serviceBadge: "Suite",
                },
              ],
            },
          ],
          offertList: {
            title: "Correo profesional",
            description4:
              "Lleva Correo Corporativo o Google Workspace, para potenciar la productividad de tu negocio.",
            description5: "Correo Corporativo desde $6.000 COP/mes/usuario.",
            description9: "Google Workspace desde $7.00 USD/mes/usuario.",
            background: "bg-op6", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "IA",
          serviceTitle: { url: "/ia", content: "Inteligencia Artificial" },
          children: [
            //row
            //{
            //    serviceList: [ //max 3 cols
            //        {
            //            serviceIcon: <SvgIconMail/>,
            //            serviceTitle: {url: "/conecta", content:"Conecta"},
            //            serviceDescription: "El uso de un correo electrónico corporativo, no solo fortalece la imagen de tu marca de manera profesional, sino que también te posiciona como un jugador serio en tu industria o sector económico.",
            //            serviceBadge: "Email"
            //        },
            //    ],
            //
            //}
          ],
          offertList: {
            title: "Correo profesional",
            description4:
              "Lleva Correo Corporativo o Google Workspace, para potenciar la productividad de tu negocio.",
            description5: "Correo Corporativo desde $6.000 COP/mes/usuario.",
            description9: "Google Workspace desde $7.00 USD/mes/usuario.",
            background: "bg-op6", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
        {
          menuTitle: "CONECTA",
          serviceTitle: { url: "/conecta", content: "CONECTA" },
          children: [
            //row
            //{
            //    serviceList: [ //max 3 cols
            //        {
            //            serviceIcon: <SvgIconMail/>,
            //            serviceTitle: {url: "/conecta", content:"Conecta"},
            //            serviceDescription: "El uso de un correo electrónico corporativo, no solo fortalece la imagen de tu marca de manera profesional, sino que también te posiciona como un jugador serio en tu industria o sector económico.",
            //            serviceBadge: "Email"
            //        },
            //    ],
            //
            //}
          ],
          offertList: {
            title: "Correo profesional",
            description4:
              "Lleva Correo Corporativo o Google Workspace, para potenciar la productividad de tu negocio.",
            description5: "Correo Corporativo desde $6.000 COP/mes/usuario.",
            description9: "Google Workspace desde $7.00 USD/mes/usuario.",
            background: "bg-op6", //bg-op1 - bg-opc2 bg-opc3 bg-opc4 bg-opc5 bg-opc6
          },
        },
      ],
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (window.pageYOffset >= 50 && this.state.sticky) {
      if (this.state.collapse !== nextState.collapse) {
        return true
      }
      return false
    } else {
      return true
    }
  }

  handleScroll = (event) => {
    if (window.pageYOffset >= 50) {
      this.setState({ sticky: true })
    } else {
      this.setState({ sticky: false })
    }
  }

  collapseNav() {
    console.log(this.state, "col")
    if (!this.state.collapse) {
      this.setState({ collapse: true })
    } else {
      this.setState({ collapse: false })
    }
  }

  render() {
    const { image, icons } = this.props
    // Mapear relativePath de íconos a gatsbyImageData
    const iconMap = {}
    icons?.nodes?.forEach((node) => {
      iconMap[node.relativePath] = getImage(
        node.childImageSharp.gatsbyImageData
      )
    })

    return (
      <Navbar className="navbar-wrapper" expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <GatsbyImage image={image} alt="VASCO Solutions" loading="eager" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              {this.state.menuOptions.map((data, index) => {
                return data.children.length === 0 ? (
                  <Link
                    className="nav-link text-white"
                    to={data.serviceTitle.url}
                  >
                    {data.menuTitle}
                  </Link>
                ) : (
                  <NavDropdown
                    key={index}
                    className="has-megamenu"
                    title={data.menuTitle}
                    id="basic-nav-dropdown"
                  >
                    <div className="row">
                      <div className="col-lg-9 service-list">
                        {data.children.map((children, idx) => (
                          <div className="row" key={idx}>
                            {children.serviceList.map(
                              (serviceList, idxService) => (
                                <div
                                  className="col-lg-4 service"
                                  key={idxService}
                                >
                                  <div className="media-left">
                                    {serviceList.serviceIcon &&
                                      iconMap[serviceList.serviceIcon] && (
                                        <GatsbyImage
                                          image={
                                            iconMap[serviceList.serviceIcon]
                                          }
                                          alt={`Ícono de ${serviceList.serviceTitle.content} para certificados SSL en Colombia`}
                                          loading="lazy"
                                          style={{ width: 32, height: 32 }}
                                          className="svc-img"
                                        />
                                      )}
                                  </div>
                                  <div className="media-body">
                                    <Link
                                      to={serviceList.serviceTitle?.url}
                                      className="media-body-title"
                                    >
                                      {serviceList.serviceTitle.content}
                                    </Link>
                                    {serviceList.serviceBadge !== "" && (
                                      <div className="media-badge">
                                        {serviceList.serviceBadge}
                                      </div>
                                    )}
                                    <p>{serviceList.serviceDescription}</p>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        ))}
                      </div>
                      <div
                        className={`col-lg-3 offert-list ${data.offertList.background}`}
                      >
                        <div className="inner">
                          <div className="inner-title">
                            {data.offertList.title}
                          </div>
                          <div className="inner-titlen">
                            {data.offertList.titlen}
                          </div>
                          <div className="inner-content">
                            {data.offertList.description}
                          </div>
                          <div className="inner-content1">
                            {data.offertList.description1}
                          </div>
                          <div className="inner-contentg1">
                            {data.offertList.descriptiong1}
                          </div>
                          <div className="inner-contentl">
                            {/* Agrega un enlace aquí */}
                            <Link to={data.offertList.link1}>
                              {data.offertList.description7}
                            </Link>
                          </div>
                          <div className="inner-content2">
                            {data.offertList.description2}
                          </div>
                          <div className="inner-contentg2">
                            {data.offertList.descriptiong2}
                          </div>
                          <div className="inner-content2">
                            {data.offertList.description3}
                          </div>
                          <div className="inner-content3">
                            {data.offertList.description8}
                          </div>
                          <div className="inner-contentw">
                            {data.offertList.description4}
                          </div>
                          <div className="inner-content2w">
                            {data.offertList.description5}
                          </div>
                          <div className="inner-content22w">
                            {data.offertList.description9}
                          </div>
                          <div className="inner-contentl">
                            {/* Agrega un enlace aquí */}
                            <Link to={data.offertList.link}>
                              {data.offertList.description6}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </NavDropdown>
                )
              })}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    )
  }
}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      query {
        logo: file(relativePath: { eq: "logos/vasco.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, height: 129)
          }
        }
        icons: allFile(
          filter: {
            relativeDirectory: { eq: "menu" }
            extension: { eq: "png" }
          }
        ) {
          nodes {
            relativePath
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, width: 32, height: 32)
            }
          }
        }
      }
    `}
    render={(data) => {
      const logoImage = getImage(data.logo.childImageSharp.gatsbyImageData)
      return <NavbarMenu image={logoImage} icons={data.icons} {...props} />
    }}
  />
)

export default Iconos
